import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ShoppingCart, Check, ArrowLeft } from "lucide-react";
import api, { money } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

export default function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { add } = useCart();
  const [p, setP] = useState(null);

  useEffect(() => {
    api.get(`/products/${id}`).then(({ data }) => setP(data)).catch(() => setP(false));
  }, [id]);

  if (p === null) return <div className="min-h-[50vh] grid place-items-center text-muted-foreground">Loading…</div>;
  if (p === false) return <div className="min-h-[50vh] grid place-items-center">Product not found.</div>;

  return (
    <div className="mx-auto max-w-5xl px-4 sm:px-6 py-8">
      <button onClick={() => navigate(-1)} className="text-sm text-muted-foreground hover:text-primary flex items-center gap-1 mb-6"><ArrowLeft size={16} /> Back</button>
      <div className="grid md:grid-cols-2 gap-8">
        <div className="rounded-xl overflow-hidden border border-border bg-muted aspect-square">
          <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
        </div>
        <div>
          <div className="text-xs uppercase tracking-wide text-muted-foreground font-semibold">{p.brand}</div>
          <h1 className="font-heading font-extrabold text-3xl tracking-tight mt-1" data-testid="product-detail-name">{p.name}</h1>
          <div className="text-muted-foreground mt-1">{p.pack_size}</div>
          <div className="mt-5 flex items-end gap-3">
            <span className="font-heading font-bold text-3xl">{money(p.price)}</span>
            {p.mrp > p.price && <span className="text-muted-foreground line-through">{money(p.mrp)}</span>}
          </div>
          {p.eligible_for_points && <Badge variant="secondary" className="mt-3 gap-1"><Check size={12} /> RicePoints eligible</Badge>}
          <p className="mt-6 text-sm text-muted-foreground">
            Manufacturer-sealed, branded product. Freshly stocked and quality checked. RicePoints can cover up to 15% of your eligible order value.
          </p>
          <Button size="lg" className="mt-8 w-full sm:w-auto" data-testid="detail-add-to-cart"
                  onClick={() => { add(p); toast.success("Added to cart"); }}>
            <ShoppingCart size={18} /> Add to Cart
          </Button>
        </div>
      </div>
    </div>
  );
}
